(function () {
  var STORAGE_KEY = 'woodera_callback_project_v1';

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function money(value) {
    var amount = Math.round(Number(value) || 0);
    return '£' + new Intl.NumberFormat('en-GB').format(amount).replace(/,/g, ' ');
  }

  function parseNumber(value) {
    if (typeof value === 'number') return value;
    if (value == null) return 0;
    var normalized = String(value).replace(/[^\d.-]/g, '');
    var parsed = Number(normalized);
    return isNaN(parsed) ? 0 : parsed;
  }

  function truthy(value) {
    var str = String(value || '').trim().toLowerCase();
    return str === 'yes' || str === 'true' || str === '1';
  }

  function hasText(value) {
    return String(value || '').trim() !== '';
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function safeSessionGet(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function safeSessionRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  }

  function getUrlProjectData(root) {
    var params = new URLSearchParams(window.location.search);

    return {
      size: params.get('size') || '',
      area_m2: params.get('area_m2') || '',
      ground_conditions: params.get('ground_conditions') || '',
      roof: params.get('roof') || '',
      doors_glazing: params.get('doors_glazing') || '',
      interior_finish: params.get('interior_finish') || '',
      fit_out: params.get('fit_out') || '',
      underfloor_heating: params.get('underfloor_heating') || '',
      planning_permission: params.get('planning_permission') || '',
      shared_boundary: params.get('shared_boundary') || '',
      base_build_ex_vat: parseNumber(params.get('base_build_ex_vat')),
      regulation_costs_ex_vat: parseNumber(params.get('regulation_costs_ex_vat')),
      chosen_upgrades_ex_vat: parseNumber(params.get('chosen_upgrades_ex_vat')),
      total_ex_vat: parseNumber(params.get('total_ex_vat')),
      total_inc_vat: parseNumber(params.get('total_inc_vat')),
      quote: params.get('quote') || '',
      structural_fee: parseNumber(root.dataset.structuralFee || 900),
      building_control_fee: parseNumber(root.dataset.buildingControlFee || 650),
      planning_fee: parseNumber(root.dataset.planningFee || 258),
      party_wall_fee: parseNumber(root.dataset.partyWallFee || 1000)
    };
  }

  function normalizeStoredData(root, data) {
    data = data || {};
    return {
      size: data.size || '',
      area_m2: data.area_m2 || '',
      ground_conditions: data.ground_conditions || '',
      roof: data.roof || '',
      doors_glazing: data.doors_glazing || '',
      interior_finish: data.interior_finish || '',
      fit_out: data.fit_out || '',
      underfloor_heating: data.underfloor_heating || '',
      planning_permission: data.planning_permission || '',
      shared_boundary: data.shared_boundary || '',
      base_build_ex_vat: parseNumber(data.base_build_ex_vat),
      regulation_costs_ex_vat: parseNumber(data.regulation_costs_ex_vat),
      chosen_upgrades_ex_vat: parseNumber(data.chosen_upgrades_ex_vat),
      total_ex_vat: parseNumber(data.total_ex_vat),
      total_inc_vat: parseNumber(data.total_inc_vat),
      quote: data.quote || '',
      structural_fee: parseNumber(data.structural_fee || root.dataset.structuralFee || 900),
      building_control_fee: parseNumber(data.building_control_fee || root.dataset.buildingControlFee || 650),
      planning_fee: parseNumber(data.planning_fee || root.dataset.planningFee || 258),
      party_wall_fee: parseNumber(data.party_wall_fee || root.dataset.partyWallFee || 1000)
    };
  }

  function hasProjectData(data) {
    return !!(
      hasText(data.size) ||
      hasText(data.area_m2) ||
      hasText(data.quote) ||
      parseNumber(data.total_ex_vat) > 0 ||
      parseNumber(data.total_inc_vat) > 0
    );
  }

  function isFormReturnState(root) {
    var params = new URLSearchParams(window.location.search);

    if (params.get('contact_posted') === 'true') {
      return true;
    }

    if (qs(root, '.rcf-form__success')) {
      return true;
    }

    if (qs(root, '.errors') || qs(root, '.form-status')) {
      return true;
    }

    return false;
  }

  function buildRow(title, subtitle, price) {
    var row = document.createElement('div');
    row.className = 'rcf-summary__row';

    var left = document.createElement('div');

    var titleEl = document.createElement('span');
    titleEl.className = 'rcf-summary__row-title';
    titleEl.textContent = title;
    left.appendChild(titleEl);

    if (subtitle) {
      var subtitleEl = document.createElement('span');
      subtitleEl.className = 'rcf-summary__row-subtitle';
      subtitleEl.textContent = subtitle;
      left.appendChild(subtitleEl);
    }

    var priceEl = document.createElement('div');
    priceEl.className = 'rcf-summary__row-price';
    priceEl.textContent = typeof price === 'number' ? money(price) : price;

    row.appendChild(left);
    row.appendChild(priceEl);

    return row;
  }

  function appendRows(container, rows) {
    if (!container) return;
    container.innerHTML = '';
    rows.forEach(function (row) {
      container.appendChild(row);
    });
  }

  function setHidden(root, key, value) {
    var input = qs(root, '[data-rcf-hidden="' + key + '"]');
    if (input) {
      input.value = value || '';
    }
  }

  function buildProjectSummaryText(data) {
    var lines = [];

    if (hasText(data.size)) lines.push('Size: ' + data.size);
    if (hasText(data.area_m2)) lines.push('Area: ' + data.area_m2 + 'm²');
    if (hasText(data.ground_conditions)) lines.push('Ground: ' + data.ground_conditions);
    if (hasText(data.roof)) lines.push('Roof: ' + data.roof);
    if (hasText(data.doors_glazing)) lines.push('Doors and glazing: ' + data.doors_glazing);
    if (hasText(data.interior_finish)) lines.push('Interior finish: ' + data.interior_finish);
    if (hasText(data.fit_out)) lines.push('Fit out: ' + data.fit_out);
    if (hasText(data.underfloor_heating)) lines.push('Underfloor heating: ' + data.underfloor_heating);
    if (hasText(data.planning_permission)) lines.push('Planning permission: ' + data.planning_permission);
    if (hasText(data.shared_boundary)) lines.push('Shared boundary: ' + data.shared_boundary);
    if (data.base_build_ex_vat) lines.push('Base build ex VAT: ' + money(data.base_build_ex_vat));
    if (data.regulation_costs_ex_vat) lines.push('Regulation costs ex VAT: ' + money(data.regulation_costs_ex_vat));
    if (data.chosen_upgrades_ex_vat) lines.push('Chosen upgrades ex VAT: ' + money(data.chosen_upgrades_ex_vat));
    if (data.total_ex_vat) lines.push('Total ex VAT: ' + money(data.total_ex_vat));
    if (data.total_inc_vat) lines.push('Total inc VAT: ' + money(data.total_inc_vat));

    return lines.join(' | ');
  }

  function getEffectiveProjectData(root) {
    var urlData = getUrlProjectData(root);

    if (hasProjectData(urlData)) {
      safeSessionSet(STORAGE_KEY, urlData);
      return urlData;
    }

    if (isFormReturnState(root)) {
      return normalizeStoredData(root, safeSessionGet(STORAGE_KEY));
    }

    safeSessionRemove(STORAGE_KEY);
    return normalizeStoredData(root, null);
  }

  function renderSummary(root, data) {
    var empty = qs(root, '[data-rcf-empty]');
    var content = qs(root, '[data-rcf-content]');
    var buildWrap = qs(root, '[data-rcf-build]');
    var regulationWrap = qs(root, '[data-rcf-regulation]');
    var choicesWrap = qs(root, '[data-rcf-choices]');
    var choicesSection = qs(root, '[data-rcf-choices-wrap]');
    var baseTotal = qs(root, '[data-rcf-base-total]');
    var regTotal = qs(root, '[data-rcf-reg-total]');
    var upgradesTotal = qs(root, '[data-rcf-upgrades-total]');
    var totalExVat = qs(root, '[data-rcf-total-exvat]');
    var totalIncVat = qs(root, '[data-rcf-total-incvat]');

    if (!hasProjectData(data)) {
      if (empty) empty.hidden = false;
      if (content) content.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (content) content.hidden = false;

    var buildRows = [];
    var regulationRows = [];
    var choiceRows = [];

    buildRows.push(
      buildRow(
        'Base build',
        [data.size, hasText(data.area_m2) ? data.area_m2 + 'm²' : ''].filter(Boolean).join(' · '),
        data.base_build_ex_vat || '—'
      )
    );

    regulationRows.push(buildRow('Structural engineer calculations', '', data.structural_fee));
    regulationRows.push(buildRow('Building Control fees', '', data.building_control_fee));

    if (truthy(data.planning_permission)) {
      regulationRows.push(buildRow('Planning application', '', data.planning_fee));
    }

    if (truthy(data.shared_boundary)) {
      regulationRows.push(buildRow('Party wall agreement (x1)', '', data.party_wall_fee));
    }

    if (hasText(data.ground_conditions)) {
      choiceRows.push(buildRow('Ground conditions', data.ground_conditions, 'Selected'));
    }

    if (hasText(data.roof)) {
      choiceRows.push(buildRow('Roof', data.roof, 'Selected'));
    }

    if (hasText(data.doors_glazing)) {
      choiceRows.push(buildRow('Doors and glazing', data.doors_glazing, 'Selected'));
    }

    if (hasText(data.interior_finish)) {
      choiceRows.push(buildRow('Interior finish', data.interior_finish, 'Selected'));
    }

    if (hasText(data.fit_out)) {
      choiceRows.push(buildRow('Fit out', data.fit_out, 'Selected'));
    }

    if (hasText(data.underfloor_heating)) {
      choiceRows.push(buildRow('Underfloor heating', data.underfloor_heating, 'Selected'));
    }

    if (hasText(data.planning_permission)) {
      choiceRows.push(buildRow('Planning permission', data.planning_permission, 'Selected'));
    }

    if (hasText(data.shared_boundary)) {
      choiceRows.push(buildRow('Shared boundary', data.shared_boundary, 'Selected'));
    }

    appendRows(buildWrap, buildRows);
    appendRows(regulationWrap, regulationRows);

    if (choicesSection && choicesWrap) {
      if (choiceRows.length) {
        choicesSection.hidden = false;
        appendRows(choicesWrap, choiceRows);
      } else {
        choicesSection.hidden = true;
        choicesWrap.innerHTML = '';
      }
    }

    if (baseTotal) {
      baseTotal.textContent = data.base_build_ex_vat ? money(data.base_build_ex_vat) : '—';
    }

    if (regTotal) {
      regTotal.textContent = data.regulation_costs_ex_vat ? money(data.regulation_costs_ex_vat) : '—';
    }

    if (upgradesTotal) {
      upgradesTotal.textContent = data.chosen_upgrades_ex_vat ? money(data.chosen_upgrades_ex_vat) : '—';
    }

    if (totalExVat) {
      totalExVat.textContent = data.total_ex_vat ? money(data.total_ex_vat) : '—';
    }

    if (totalIncVat) {
      totalIncVat.textContent = data.total_inc_vat ? 'Inc. VAT: ' + money(data.total_inc_vat) : 'Inc. VAT: —';
    }
  }

  function fillHiddenProjectFields(root, data) {
    setHidden(root, 'project_summary', buildProjectSummaryText(data));
    setHidden(root, 'quote', data.quote || '');
    setHidden(root, 'size', data.size || '');
    setHidden(root, 'area_m2', data.area_m2 || '');
    setHidden(root, 'ground_conditions', data.ground_conditions || '');
    setHidden(root, 'roof', data.roof || '');
    setHidden(root, 'doors_glazing', data.doors_glazing || '');
    setHidden(root, 'interior_finish', data.interior_finish || '');
    setHidden(root, 'fit_out', data.fit_out || '');
    setHidden(root, 'underfloor_heating', data.underfloor_heating || '');
    setHidden(root, 'planning_permission', data.planning_permission || '');
    setHidden(root, 'shared_boundary', data.shared_boundary || '');
    setHidden(root, 'base_build_ex_vat', data.base_build_ex_vat ? money(data.base_build_ex_vat) : '');
    setHidden(root, 'regulation_costs_ex_vat', data.regulation_costs_ex_vat ? money(data.regulation_costs_ex_vat) : '');
    setHidden(root, 'chosen_upgrades_ex_vat', data.chosen_upgrades_ex_vat ? money(data.chosen_upgrades_ex_vat) : '');
    setHidden(root, 'total_ex_vat', data.total_ex_vat ? money(data.total_ex_vat) : '');
    setHidden(root, 'total_inc_vat', data.total_inc_vat ? money(data.total_inc_vat) : '');
    setHidden(root, 'source_url', window.location.href);
  }

  function splitPhoneValue(value, selectEl, localEl) {
    if (!value || !selectEl || !localEl) return;

    var cleaned = String(value).trim();
    if (!cleaned) return;

    var options = Array.prototype.slice.call(selectEl.options)
      .map(function (option) {
        return option.value;
      })
      .sort(function (a, b) {
        return b.length - a.length;
      });

    var matchedCode = '';
    options.forEach(function (code) {
      if (!matchedCode && cleaned.indexOf(code) === 0) {
        matchedCode = code;
      }
    });

    if (matchedCode) {
      selectEl.value = matchedCode;
      localEl.value = cleaned.slice(matchedCode.length).trim();
      return;
    }

    localEl.value = cleaned;
  }

  function syncPhoneField(root) {
    var countrySelect = qs(root, '[data-rcf-country-select]');
    var localInput = qs(root, '[data-rcf-phone-local]');
    var hiddenPhone = qs(root, '[data-rcf-phone-hidden]');

    if (!countrySelect || !localInput || !hiddenPhone) return;

    var code = String(countrySelect.value || '').trim();
    var local = String(localInput.value || '').trim().replace(/\s+/g, ' ');
    hiddenPhone.value = local ? (code + ' ' + local).trim() : '';
  }

  function initPhoneField(root) {
    var countrySelect = qs(root, '[data-rcf-country-select]');
    var localInput = qs(root, '[data-rcf-phone-local]');
    var hiddenPhone = qs(root, '[data-rcf-phone-hidden]');
    var formEl = qs(root, '#RequestCallbackForm');

    if (!countrySelect || !localInput || !hiddenPhone || !formEl) return;

    if (hiddenPhone.value) {
      splitPhoneValue(hiddenPhone.value, countrySelect, localInput);
    }

    countrySelect.addEventListener('change', function () {
      syncPhoneField(root);
    });

    localInput.addEventListener('input', function () {
      syncPhoneField(root);
    });

    formEl.addEventListener('submit', function () {
      syncPhoneField(root);
    });

    syncPhoneField(root);
  }

  function init(root) {
    if (!root || root.dataset.rcfReady === 'true') return;
    root.dataset.rcfReady = 'true';

    var data = getEffectiveProjectData(root);
    renderSummary(root, data);
    fillHiddenProjectFields(root, data);
    initPhoneField(root);
  }

  function initAll(scope) {
    qsa(scope || document, '[data-rcf-root]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
